module.exports = __webpack_public_path__ + "img/camera-corner-top-left.3a13e295.png";